import { Component, inject, OnInit } from '@angular/core';
import { MenuComponentBase } from '../../../../shared/base-classes/menu-component-base';
import { ProfileService } from '../../services/profile.service';
import { ImageService } from '../../../../shared/services/image-service/image.service';
import { UserDetails } from '../../../../shared/models/user';
import { ContainerSasUrl } from '../../../../shared/interfaces/company';
import { forkJoin, switchMap, takeUntil } from 'rxjs';
import { Location, CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-profile-details',
  templateUrl: './user-profile-details.component.html',
  styleUrls: ['./user-profile-details.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class UserProfileDetailsComponent
  extends MenuComponentBase
  implements OnInit
{
  profileService = inject(ProfileService);
  imageService = inject(ImageService);
  private location = inject(Location);
  private router = inject(Router);
  userProfileDetails!: UserDetails;
  containerSasUrl!: ContainerSasUrl;
  userId!: number;
  isLoading = false;
  isNotFound = false;
  showBackButton = false;
  backButtonText = 'Back to Record';
  private fromNotifications = false;

  override ngOnInit(): void {
    super.ngOnInit();

    // Detect if user navigated here from record-details component or notifications.
    // Router stores extras.state in the browser's history.state object.
    const historyState = history.state as {
      fromRecordDetails?: boolean;
      fromNotifications?: boolean;
    };
    if (historyState?.fromNotifications) {
      this.showBackButton = true;
      this.fromNotifications = true;
      this.backButtonText = 'Back to Notifications';
    } else if (historyState?.fromRecordDetails) {
      this.showBackButton = true;
      this.backButtonText = 'Back to Record';
    }

    this.isLoading = true;
    this.route.paramMap
      .pipe(
        switchMap((params) => {
          return forkJoin({
            details: this.profileService.getSMEUserProfileDetails(
              params.get('id') || '',
            ),
            sasUrl: this.imageService.getContainerSasUrl(),
          });
        }),
        takeUntil(this.destroy$),
      )
      .subscribe({
        next: ({ details, sasUrl }) => {
          this.containerSasUrl = sasUrl;
          this.userProfileDetails = details;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
          this.isNotFound = true;
        },
      });
  }

  getImageUrl(path: string): string {
    if (!this.containerSasUrl || !path) return '';
    return `${path}?${this.containerSasUrl.sas_token}`;
  }

  goBack(): void {
    if (this.fromNotifications) {
      this.router.navigate(['/notifications']);
    } else {
      this.location.back();
    }
  }
}
